/**
 * TanStack Query hooks for `igaming-wager-events-granular`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingWagerEventsGranularQueryKeys,
	type CreateIgamingWagerEventsGranularBody,
	type ListIgamingWagerEventsGranularResponse,
	type IgamingWagerEventsGranularRow,
} from "./api";

export function useIgamingWagerEventsGranularList(): UseQueryResult<ListIgamingWagerEventsGranularResponse, Error> {
	return useQuery({
		queryKey: igamingWagerEventsGranularQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingWagerEventsGranularCreate(): UseMutationResult<IgamingWagerEventsGranularRow, Error, CreateIgamingWagerEventsGranularBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingWagerEventsGranularQueryKeys.all });
		},
	});
}

export function useIgamingWagerEventsGranularDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingWagerEventsGranularQueryKeys.all });
		},
	});
}
